export const editProfileFormSchema = {
    type: 'VerticalLayout',
    elements: [
        {
            type: 'Control',
            label: 'Name',
            scope: '#/properties/NAME',
        },
        {
            type: 'Control',
            label: 'Description',
            scope: '#/properties/DESCRIPTION',
        },
        {
            type: 'Control',
            label: 'Status',
            scope: '#/properties/STATUS',
        },
        {
            type: 'Control',
            label: 'Rights',
            scope: '#/properties/RIGHT_CODES',
            options: {
                allOptionsResourceName: 'RIGHT',
                valueField: 'CODE',
                labelField: 'CODE',
            },
        },
        {
            type: 'Control',
            label: 'Users',
            scope: '#/properties/USER_NAMES',
            options: {
                allOptionsResourceName: 'USER',
                valueField: 'USER_NAME',
                labelField: 'USER_NAME',
            },
        },
    ],
};
